import React from "react";
import { useAppConfig } from "../../../../AppConfigProvider";
import InteractiveLearningFormDataContainer from "../../../../containers/customCoursework/InteractiveLearningForm/InteractiveLearningFormDataContainer";
import type { ActivityDataInput } from "../../../../components/customCoursework/ActivityForms/InteractiveLearningForm/InteractiveLearningFormCore";
type InteractiveLearningFormProps = {
  activityData?: ActivityDataInput;
  onSave: (data: ActivityDataInput) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
};

const InteractiveLearningForm = ({ activityData, onSave, onCancel, isSubmitting }: InteractiveLearningFormProps) => {
  const appConfig = useAppConfig();
  const currentDomain = appConfig?.currentDomain;
  const imageGenerationSupportFlag = appConfig?.imageGenerationSupportFlag;

  return (
    <InteractiveLearningFormDataContainer
      activityData={activityData}
      onSave={onSave}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      currentDomain={currentDomain}
      imageGenerationSupportFlag={imageGenerationSupportFlag}
    />
  );
};

export default InteractiveLearningForm;
